import { render, staticRenderFns } from "./tutorial-page.vue?vue&type=template&id=792cd639&scoped=true&lang=pug&"
import script from "./tutorial-page.vue?vue&type=script&lang=js&"
export * from "./tutorial-page.vue?vue&type=script&lang=js&"
import style0 from "./tutorial-page.vue?vue&type=style&index=0&id=792cd639&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792cd639",
  null
  
)

export default component.exports